// extracted by mini-css-extract-plugin
export default {"homePage":"Home_homePage__gNdkv","squaresContainer":"Home_squaresContainer__znMDk","buttonCover":"Home_buttonCover__PGTye","p":"Home_p__aKaPU"};